import React from 'react';


import Backdrop from './Backdrop2';

import styled from 'styled-components';


const Spinner = styled.div`
    width: 35%;
    padding: 3%;
    position: fixed;
    z-index: 700;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 12%;
    left: calc(32%);
    background: white;
    border-radius: 5px;
`
const primaryModal = (props) => (
   <div>
     <Backdrop clicked={props.closeModal} show={props.show} />
     <Spinner
     style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? '1': '0'

    }}
     >
      {props.children}
    </Spinner>
   </div>
);

export default primaryModal;